<template>
    <van-config-provider :theme-vars="themeVars">
    <div class="van-hairline--surround">
         <van-cell-group inset border="false">
           <h3 style="padding-top: 1em;">太和县人民医院中医科简介</h3>
           <p class="textIndentation">我院中医内科前身是中医科，始建于1950年。1984年7月成立中医住院部，是一个教集科研学临床医疗康复为一体的综合性一级临床科室。随着国人对中医药的认可，中医科蓬勃发展，自2011年下半年开始至2016年下半年组建分出中医康复科及中西医结合风湿免疫科。
           </p>
         </van-cell-group>
          <br/>
   
     <van-cell-group inset>
          <van-divider :style="{ color: '#EA6853', borderColor: '#EA6853', padding: '0 16px' }">中医内科学科队伍</van-divider>
          <p class="textIndentation">中医内科现有医护人员15人，学科带头人为副主任医师，为安徽省中医药学会肿瘤专业委员会常务委员，安徽省康复医学会糖尿病专业委员会常务委员，安徽省老年病医学会委员。国家基层中医药工作先进个人。科内有硕士研究生2人，主治医师2人，主管护师1人。
           </p>
          <van-image src="https://keshi-1258265833.cos.ap-nanjing.myqcloud.com/taihe/2005180857134596.jpg.thumb.500x500.jpg" />
      </van-cell-group>
      <van-cell-group inset>
          <van-divider :style="{ color: '#EA6853', borderColor: '#EA6853', padding: '0 16px' }">研究发展方向</van-divider>
          <p class="textIndentation">中医内科学在临床、教学、科研等方面协同发展。中医药在心脑血管、呼吸系统疾病、亚健康领域疾病的防治取得了明显的效果与进展。并能促进肿瘤患者生活质量的改善，抑制肿瘤发展，改善放化疗后的毒副反应，缓解症状，增强体质，降低恶性肿瘤转移及复发的危险性。自拟清瘀汤联合钻孔引流术治疗硬膜下血肿，耳穴压豆治疗各种疼痛及各类失眠均取得满意的疗效。
           </p>
      </van-cell-group>
      <van-cell-group inset>
          <van-divider :style="{ color: '#EA6853', borderColor: '#EA6853', padding: '0 16px' }">特色与优势</van-divider>
          <p class="textIndentation">中医内科在继承发掘传统中医学精髓的同时，注重吸收和运用现代医学先进诊疗手段，强调整体观念，辨证论治，对内科常见病多发病及各种疑难杂症形成了一套行之有效的方法，与理疗，耳穴压豆，中药敷贴，中药熏蒸，心理治疗等相结合，合理有序地用于具体病人，具体疾病，获得良好的疗效。
注重发挥中医“治未病”优势，传播“未病先防、既病防变、愈后防复”理念，积极探索治未病工作机制，推广中医预防保健、养生康复等服务，开展中医药特色诊疗项目，积极开展冬病夏治，冬病冬治，利用中医药诊疗项目的特色与优势，让更多老百姓了解其中医原理适宜人群注意事项等。在各种疾病预防与控制中积极支持运用中医药方法和适宜技术，推动中医药预防保健服务。
           </p>
      </van-cell-group>
      <van-cell-group inset>
          <van-divider :style="{ color: '#EA6853', borderColor: '#EA6853', padding: '0 16px' }">名医专家：闫永霞</van-divider>
          <p class="textIndentation">擅长各类常见病、多发病的诊断和治疗，对中医中药、妇科、更年期综合症、心理疾病、疑难杂症等有自己的独特见解。
           </p>
           <van-image src="https://keshi-1258265833.cos.ap-nanjing.myqcloud.com/taihe/2209020832244609.jpg.thumb.500x500.jpg" />
      </van-cell-group>
      <van-cell-group inset>
          <van-divider :style="{ color: '#EA6853', borderColor: '#EA6853', padding: '0 16px' }">名医专家：张琳琳</van-divider>
          <p class="textIndentation">擅长运用中医理论治疗脾胃病、中风偏瘫后遗症、失眠、便秘、更年期综合征及老年痴呆症等疾病，充分发挥中医特长抑制肿瘤发展，减少各种癌症放化疗后的毒副反应，提高癌症患者的生活质量，降低肿瘤转移及复发的危险性。安徽省中医药学会肿瘤专业委员会常务委员，安徽省康复医学会糖尿病专业委员会常务委员，安徽省老年病医学会委员。国家基层中医药工作先进个人。
           </p>
           <van-image src="https://keshi-1258265833.cos.ap-nanjing.myqcloud.com/taihe/1908291612239046.jpg.thumb.500x500.jpg" />
      </van-cell-group>
         <p class="match">
            <van-notice-bar color="#EA6853" wrapable :scrollable="false">
              <strong>中医讲究望闻问切，分析部分仅作为参考。如果有不适，需要到院进一步诊断，点击按钮，会将您的情况同步给中医科室</strong>
           </van-notice-bar>
        </p>
        <van-button color="linear-gradient(to right, #f67f34, #d55809)" round block @click="toDoctorData">将个人信息同步到医生</van-button>
     </div>
   </van-config-provider>
  </template>
  <script>
  import { reactive, onMounted } from 'vue';
  import {postToDoctorData } from "../../api/doctor";
  import { postUserLog } from '../../api/userlog'
  import { useRouter } from 'vue-router';
  import { showDialog } from 'vant';
  export default {
   setup() {
  
     const themeVars = reactive({
       cellGroupBackground: '#F1F1F1',
     });
     const kpian = reactive({
       cellGroupBackground: '#AAAAAA',
     });
     const kpianawait = reactive({
       cellGroupBackground: '#F1F1F1',
     });
     const themeVars2 = reactive({
       cellGroupBackground: '#F1F1F1',
     });
     const router = useRouter(); 
     const ulog = reactive({
        UserLog: {
          path: '',
        }
      });
      const toDoctorData = () => {
            console.log("===toDoctorData===");
            postToDoctorData().then((res) => {
                if(res.data.code == 0){
                    showDialog({
                        title: "数据同步成功",
                        message: "您的情况我们已经同步给医生，请您尽快前往我院中医科进一步核查情况！",
                        theme: "round-button",
                    }).then(() => {
                    
                    });
                }else{
                    showDialog({
                        title: "同步失败",
                        message: "网络异常提交失败，请稍后重试",
                        theme: "round-button",
                    }).then(() => {
                        
                    });
                }
            });
        };
     onMounted(() => {
          ulog.UserLog.path = router.currentRoute.value.fullPath;
          console.log("当前页面路径=="+ulog.UserLog.path) 
          postUserLog(ulog.UserLog).then(() => {
           
          })
          //自动同步到中医科
          postToDoctorData().then((res) => {
                if(res.data.code == 0){
                  console.log("数据同步到中医科") 
                }
            });
     })
     return {
       toDoctorData,
       themeVars,
       kpian,
       kpianawait,
       themeVars2,
     }
   }
  }
  </script>
  <style scoped>
  #app {
   font-family: Avenir, Helvetica, Arial, sans-serif;
   -webkit-font-smoothing: antialiased;
   -moz-osx-font-smoothing: grayscale;
   text-align: center;
   color: #2c3e50;
  }
  
  .textIndentation {
   text-align: left;
   text-indent: 2em;
   font-weight: bold;
   font-size: 14px;
   padding-top: 1em;
   padding-right: 1em;
   padding-bottom: 1em;
   padding-left: 1em;
   line-height:30px;
  }
  
  .text2Indentation {
   text-align: left;
   text-indent: 2em;
   font-weight: bold;
   font-size: 14px;
   padding-top: 1px;
   padding-right: 1em;
   padding-bottom: 1em;
   padding-left: 1em;
  }
  
  .match {
   text-align: left;
   text-indent: 1em;
   font-size: 14px;
  }
  
  .text3Indentation {
   text-align: left;
   font-weight: bold;
   font-size: 14px;
   padding-top: 1em;
   padding-right: 1em;
   padding-bottom: 1em;
   padding-left: 1em;
  }
  </style>
  